import React from 'react';
import { useParams } from 'react-router-dom';
import ManageToiture from './Components/ManageToiture';
import Toiture from './Components/Toiture/Toiture';
import MurUsage from './Components/MurUsage';
import Charpente from './Components/Charpente';
import Cadrage from './Components/Cadrage';
import DimensionsPlans from './Components/DimensionsPlans';
import BeHead from '../../Components/Head/BeHead';

function ManageBeStep() {

  const { nom } = useParams(); // récupère le nom encodé dans l'URL

  return (
    <div>
      <div className="content-body">
        <div className="container-fluid">
          <h2>Modifier l'étape {decodeURIComponent(nom)}</h2>
          {decodeURIComponent(nom) === 'TOITURE' && <ManageToiture />}
          {/* {decodeURIComponent(nom) === 'TOITURE' && <Toiture />} */}
          {decodeURIComponent(nom) === 'MUR ET USAGE' && <MurUsage />}
          {decodeURIComponent(nom) === 'CHARPENTE' && <Charpente />}
          {decodeURIComponent(nom) === 'CADRAGE DU PROJET' && <Cadrage />}
          {decodeURIComponent(nom) === 'DIMENSIONS ET PLANS' && <DimensionsPlans />}
        </div>
      </div>
    </div>
  );
}

export default ManageBeStep;